import React, { useState, useEffect, useRef } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import Input from '../_Components/Input'
import Variables from '../../global'
import { use } from '../../Helpers'
import { call } from '../../Methods'

export default function _UserEdit () {
  const pageTitle = 'Users'
  const { id } = useParams()
  const navigate = useNavigate()
  const [user, setUser] = useState(null)
  const [countries, setCountries] = useState(null)
  const [roles, setRoles] = useState(null)
  const [statuses, setStatuses] = useState(null)
  const [loading, setLoading] = useState(false)

  const getData = async () => {
    setLoading(true)
    const _roles = await call.forLoggedUser.user.getRoles({})
    if (_roles.success) {
      setRoles(_roles.data)
    }
    const _user = await call.forLoggedUser.user.getUser({ id: id })
    if (_user.success) {
      setUser(_user.data)
    }
    const _countries = await call.forLoggedUser.country.getCountryList({})
    if (_countries.success) {
      setCountries(_countries.data)
    }

    const _statuses = await call.forLoggedUser.statuses.getStatuses({
      type: 'User'
    })
    if (_statuses?.success) {
      setStatuses(_statuses.data)
    }
    setLoading(false)
  }

  useEffect(() => {
    getData()
  }, [])

  const saveData = async e => {
    console.log('hello')
    setLoading(true)
    let uploaded_image = document.querySelector(
      'img[name="input-image-preview"]'
    )?.dataset['base64']

    let _user = {
      id:id,
      email:use.getInputValueByName('email'),
      userName:use.getInputValueByName('userName'),
      firstName: use.getInputValueByName('firstName'),
      lastName: use.getInputValueByName('lastName'),
      companyName: use.getInputValueByName('companyName'),
      phone: use.getInputValueByName('phone'),
      image: {
        base64: uploaded_image
      },
      countryId: use.getInputValueByName('countryId'),
      city: use.getInputValueByName('city'),
      address: use.getInputValueByName('address'),
      postalCode: use.getInputValueByName('postalCode'),
      roleId: use.getInputValueByName('roleId'),
      active: use.getInputValueByName('active')
    }

    console.log(_user);

    const _updateUserResponse = await call.forLoggedUser.user.updateUser(_user)

    if (_updateUserResponse.success) {
      setUser(_updateUserResponse.data)
    }
    setLoading(false);
  }

  const updateStatus = async e => {
    setLoading(true)
    let _user = {
      id: id,
      statusId: use.getInputValueByName('statusId')
    }

    const _updateStatusResponse = await call.forLoggedUser.user.updateUser(
      _user
    )
    if (_updateStatusResponse.success) {
      setUser(_updateStatusResponse.data)
      navigate(`/admin/user/${_updateStatusResponse.data.id}`, {
        replace: true
      })
    }
    setLoading(false)
  }

  return (
    !loading && statuses && countries &&
    user && (
      <React.Fragment>
        <form className='form'>
        <h4 className='form-title'>{pageTitle} {'/'} {user?.email || user?.userName}</h4>
       
            <div className='row'>
              <Input
                type={'email'}
                label={'Email'}
                required
                fieldName={'email'}
                col={{ default: 12, sm: 6, md: 3 }}
                value={user?.email}
              />
              <Input
                type={'text'}
                label={'User Name'}
                fieldName={'userName'}
                disabled={true}
                col={{ default: 12, sm: 6, md: 3 }}
                value={user?.userName}
              />
              <Input
                type={'select'}
                label={'Role'}
                required
                fieldName={'roleId'}
                data={roles.map(({ id, name }) => {
                  return { value: id, text: name }
                })}
                col={{ default: 12, sm: 6, md: 3 }}
                defaultValue={user?.roleId}
              />
              <Input
                type={'checkbox'}
                label={'Enabled'}
                fieldName={'active'}
                col={{ default: 12, sm: 6, md: 3 }}
                value={user?.active}
              />
              <Input
                type={'text'}
                label={'First Name'}
                required
                fieldName={'firstName'}
                col={{ default: 12, sm: 6, md: 3 }}
                value={user?.firstName}
              />
              <Input
                type={'text'}
                label={'Last Name'}
                required
                fieldName={'lastName'}
                col={{ default: 12, sm: 6, md: 3 }}
                value={user?.lastName}
              />
              <Input
                type={'text'}
                label={'Company Name'}
                fieldName={'companyName'}
                col={{ default: 12, sm: 6, md: 3 }}
                value={user?.companyName}
              />
              <Input
                type={'text'}
                label={'Phone Number'}
                fieldName={'phone'}
                col={{ default: 12, sm: 6, md: 3 }}
                value={user?.phone}
              />
              <label className='group-label'>Shipping Address</label>
              <Input
                type={'select'}
                label={'Country'}
                required
                fieldName={'countryId'}
                data={countries.map(({ id, name }) => {
                  return { value: id, text: name }
                })}
                col={{ default: 12, sm: 4, md: 2 }}
                defaultValue={user?.countryId?.toString()}
              />
              <Input
                type={'text'}
                label={'City'}
                fieldName={'city'}
                col={{ default: 12, sm: 4, md: 2 }}
                value={user.city}
              />
              <Input
                type={'text'}
                label={'Address'}
                fieldName={'address'}
                col={{ default: 12, sm: 12, md: 6 }}
                value={user.address}
              />
              <Input
                type={'text'}
                label={'Postal Code'}
                fieldName={'postalCode'}
                col={{ default: 12, sm: 4, md: 2 }}
                value={user.postalCode}
              />
              <div className='action-buttons'>
                <button
                  type='button'
                  className='back-button'
                  onClick={() => navigate('/admin/users', { replace: true })}
                >
                  Back
                </button>
                <button
                  type='button'
                  className='save-button'
                  onClick={e => saveData()}
                >
                  Update User
                </button>
              </div>
            </div>
        </form>

        <form className='form'>
          <div id='status-row' className='row'>
            <label className='group-label'>Set Status</label>
            <Input
              type={'select'}
              label={'Status'}
              fieldName={'statusId'}
              data={statuses.map(({ id, statusName }) => {
                return { value: id, text: statusName }
              })}
              col={{ default: 12, sm: 4, md: 3 }}
              defaultValue={user.statusId.toString()}
            />
            <Input
              type={'button'}
              fieldName={'Update'}
              className={'action-button approve-button'}
              style={{ position: 'relative', top: '17px' }}
              col={{ default: 12, sm: 4, md: 2 }}
              value={'Update'}
              eventHandler={[{ type: 'click', handler: updateStatus }]}
            />
          </div>
        </form>
      </React.Fragment>
    )
  )
}
